import { Box, Typography } from '@mui/material'
import SwitchOverided from '../../utilsComponents/SwitchOverided'
import { sxs } from '../_styles'
import { PreferencesSwitchProps } from './_props'

const PreferencesSwitch = ({ checked, onChange, name, label }: PreferencesSwitchProps) => (
    <Box display="flex" alignItems="center" paddingTop="1rem">
        <SwitchOverided checked={checked} onChange={onChange} name={name} />
        <Typography sx={sxs.labelSwitchContent}>{label}</Typography>
    </Box>
)
export default PreferencesSwitch
